//@ts-nocheck
import React from "react";
import { Button, ButtonProps } from "react-bootstrap";

const ButtonForm = ({
  id = "",
  value,
  icon = "",
  disabled = false,
  ...rest
}) => {
  return (
    <>
      <Button type="button" id={id} disabled={disabled} {...rest}>
        {value}
      </Button>
    </>
  );
};

export default ButtonForm;
